import { render } from "./StartDashboard.vue?vue&type=template&id=5f0e1550&scoped=true"
import script from "./StartDashboard.vue?vue&type=script&lang=js"
export * from "./StartDashboard.vue?vue&type=script&lang=js"

import "./StartDashboard.vue?vue&type=style&index=0&id=5f0e1550&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0e1550"]])

export default __exports__